module.exports = __webpack_public_path__ + "img/feature4.0eeffa49.jpg";